import { api } from "@/plugins/api";
const url = "/api/v1";
import * as store from "@/store";
import * as cmUtil from "@/utils/cmUtil";
import * as orderApi from "@/api/orderApi.js";
import axios from "axios";
const Buffer = require("buffer/").Buffer;

export async function getPageInitData(_mparm = []) {
  let mparm = [..._mparm];
  mparm.push({ qId: "userLoginInfo" });
  mparm.push({ qId: "system" });
  mparm.push({ qId: "userBasketCount" });
  mparm.push({ qId: "userAlimCount" });
  mparm.push({ qId: "userPersonInfo" });

  let pathList = [
    { pathname: "/paintpro/orderList", prgrmId: "1" },
    { pathname: "/paintpro/orderList/shipmentList", prgrmId: "2" },
    { pathname: "/paintpro/orderList/purchaseList", prgrmId: "3" },
    { pathname: "/paintpro/colorCombinList", prgrmId: "4" },
    { pathname: "/paintpro/colorCombinList/updateList", prgrmId: "5" },
    { pathname: "/paintpro/colorCombinList/colorSearch", prgrmId: "6" },
    { pathname: "/paintpro/custCenterList/reqList", prgrmId: "7" },
    { pathname: "/paintpro/custCenterList/noticeList", prgrmId: "8" },
    { pathname: "/paintpro/custCenterList/munsellColorSearch", prgrmId: "9" },
  ];

  const findPathItem = pathList.find(
    (item) => item.pathname == location.pathname
  );
  if (findPathItem) {
    mparm.push({
      qId: "insertMenuUseHist",
      parm: { ...findPathItem },
    });
  }

  const res = await api.post(`${url}/common/pageInitData`, {
    mparm: mparm,
  });
  const { resultCode } = res;
  if (resultCode === 200) {
    const _userLoginInfo = res.data?.userLoginInfo || {};
    store.useAuthStore().setLoginUser(_userLoginInfo);
    const _userAlimCount = res.data?.userAlimCount || 0;
    store.useAlimCountStore().setAlimCount(_userAlimCount);
    const _userBasketCount = res.data?.userBasketCount || 0;
    store.useBasketCountStore().setBasketCount(_userBasketCount);
    const _systemNoticeYn = res.data?.system?.pproSysChckYn || "";
    store.useEventBusStore().setSystemNoticeYn(_systemNoticeYn);
  }
  cmUtil.checkSystemNotice();
  return res;
}
export async function setLoginInitData(parm = {}) {
  if (!(await isLoginApi()).data) {
    cmUtil.toast(`로그인하시기 바랍니다.`, { type: "basket" });
    return false;
  }
  const res = await api.post(`${url}/comEvnt/setLoginInitData`, parm);
  return res;
}
export async function logout() {
  const res = await api.post(`${url}/common/logout`, {});
  cmUtil.resetStore();
  return res;
}
export async function isLoginApi() {
  return await api.post(`${url}/common/isLoginApi`, {});
}
export async function selectLoginUserApi() {
  return await api.post(`${url}/common/selectLoginUserApi`, {});
}
export async function selectCodes(_mparm = []) {
  let mparm = [..._mparm];
  const res = await api.post(`${url}/common/selectCodes`, {
    mparm: mparm,
  });
  return res;
}
export async function selectSystem() {
  return await api.post(`${url}/common/selectSystem`, {});
}

export async function selectUserPersonInfo() {
  return await api.post(`${url}/common/selectUserPersonInfo`, {});
}
export async function selectUserSalesEmpList() {
  return await api.post(`${url}/common/selectUserSalesEmpList`, {});
}
export async function selectUserBasketCount() {
  return await api.post(`${url}/common/selectUserBasketCount`, {});
}
export async function selectUserBasketList() {
  return await api.post(`${url}/common/selectUserBasketList`, {});
}
export async function selectUserRecentlyProdCount() {
  return await api.post(`${url}/common/selectUserRecentlyProdCount`, {});
}
export async function selectUserRecentlyProdList() {
  return await api.post(`${url}/common/selectUserRecentlyProdList`, {});
}
export async function deleteUserRecentlyProdList(list) {
  return await api.post(`${url}/common/deleteUserRecentlyProdList`, list);
}
export async function selectUserAlimList() {
  return await api.post(`${url}/common/selectUserAlimList`, {});
}
export async function selectUserAlimCount() {
  return await api.post(`${url}/common/selectUserAlimCount`, {});
}
export async function selectUserBookmarkMenuList() {
  return await api.post(`${url}/common/selectUserBookmarkMenuList`, {});
}
export async function selectUserBookmarkProdList() {
  return await api.post(`${url}/common/selectUserBookmarkProdList`, {});
}
export async function selectUserMainToolbarList() {
  return await api.post(`${url}/common/selectUserMainToolbarList`, {});
}
export async function selectCommonPopupCount() {
  const { isMobile } = cmUtil.useDeviceType();
  return await api.post(`${url}/common/selectCommonPopupCount`, {
    deviceType: isMobile.value ? "M" : "P",
  });
}

export async function insertMenuUseHist() {
  if (!(await isLoginApi()).data) {
    cmUtil.toast(`로그인하시기 바랍니다.`, { type: "basket" });
    return false;
  }

  let pathList = [
    { pathname: "/paintpro/orderList", prgrmId: "1" },
    { pathname: "/paintpro/orderList/shipmentList", prgrmId: "2" },
    { pathname: "/paintpro/orderList/purchaseList", prgrmId: "3" },
    { pathname: "/paintpro/colorCombinList", prgrmId: "4" },
    { pathname: "/paintpro/colorCombinList/updateList", prgrmId: "5" },
    { pathname: "/paintpro/colorCombinList/colorSearch", prgrmId: "6" },
    { pathname: "/paintpro/custCenterList/reqList", prgrmId: "7" },
    { pathname: "/paintpro/custCenterList/noticeList", prgrmId: "8" },
    { pathname: "/paintpro/custCenterList/munsellColorSearch", prgrmId: "9" },
  ];

  const findPathItem = pathList.find(
    (item) => item.pathname == location.pathname
  );
  if (findPathItem) {
    return null;
  }
  const res = await api.post(`${url}/common/insertMenuUseHist`, {
    ...findPathItem,
  });
  return res;
}

export async function selectCommonPopupList(parm = {}) {
  return await api.post(`${url}/common/selectCommonPopupList`, parm);
}
export async function updateUserAlimRead(parm = {}) {
  const { isMobile } = cmUtil.useDeviceType();
  let validItems = [
    { name: "alarmTaskSn", title: "알림번호" },
    { name: "alarmTaskSeCd", title: "게시물구분코드" },
  ];
  let validMsg = "";
  for (let i = 0; i < validItems.length; i++) {
    if (parm[validItems[i].name] == null || parm[validItems[i].name] == "") {
      validMsg += `${validItems[i].title} 정보가 없습니다.`;
      break;
    }
  }
  if (validMsg) {
    cmUtil.toast(`${validMsg}`, { type: "basket" });
    return false;
  }

  // api 로그인여부 체크
  if (!(await isLoginApi()).data) {
    cmUtil.toast(`로그인하시기 바랍니다.`, { type: "basket" });
    return false;
  }

  const res = await api.post(`${url}/common/updateUserAlimRead`, {
    ...parm,
    inqChnlCd: isMobile.value ? "M" : "P",
  });

  const { resultCode, data } = res;

  if (resultCode === 200) {
    store.useAlimCountStore().setAlimCount(data);
  }
  return res;
}


export async function updateUserPstInqHist(parm = {}) {
  const { isMobile } = cmUtil.useDeviceType();
  let validItems = [
    { name: "pstSeCd", title: "게시물구분코드" },
    { name: "pstNo", title: "게시물번호" },
  ];
  let validMsg = "";
  for (let i = 0; i < validItems.length; i++) {
    if (parm[validItems[i].name] == null || parm[validItems[i].name] == "") {
      validMsg += `${validItems[i].title} 정보가 없습니다.`;
      break;
    }
  }
  if (validMsg) {
    cmUtil.toast(`${validMsg}`, { type: "basket" });
    return false;
  }

  // api 로그인여부 체크
  if (!(await isLoginApi()).data) {
    cmUtil.toast(`로그인하시기 바랍니다.`, { type: "basket" });
    return false;
  }

  const res = await api.post(`${url}/common/updateUserPstInqHist`, {
    ...parm,
    inqChnlCd: isMobile.value ? "M" : "P",
  });

  const { resultCode, data } = res;

  if (resultCode === 200) {
    store.useAlimCountStore().setAlimCount(data);
  }
  return res;
}
//알림 모두 읽기
export async function updateUserAlimAllRead(parm = {}) {
  const { isMobile } = cmUtil.useDeviceType();
  let validMsg = "";
  let alimParamList = parm.params.api;
  if (alimParamList.SD_ITEM.item.length < 1) {
    validMsg += `알림 정보가 없습니다.`;
  }
  if (validMsg) {
    cmUtil.toast(`${validMsg}`, { type: "basket" });
    return false;
  }

  // api 로그인여부 체크
  if (!(await isLoginApi()).data) {
    cmUtil.toast(`로그인하시기 바랍니다.`, { type: "basket" });
    return false;
  }
  

  const res = await api.post(`${url}/common/updateUserAlimAllCheck`, {
    ...alimParamList,
    inqChnlCd: isMobile.value ? "M" : "P",
  });

  const { resultCode, data } = res;

  if (resultCode === 200) {
    store.useAlimCountStore().setAlimCount(data);
  }
  return resultCode;
}
export async function updateUserBasketProd(parm = {}) {
  let validItems = [
    { name: "goodsSn", title: "상품번호" },
    { name: "goodsQty", title: "상품수량" },
  ];
  let validMsg = "";
  for (let i = 0; i < validItems.length; i++) {
    if (parm[validItems[i].name] == null || parm[validItems[i].name] == "") {
      validMsg += `${validItems[i].title} 정보가 없습니다.`;
      break;
    }
  }
  if (validMsg) {
    cmUtil.toast(`${validMsg}`, { type: "basket" });
    return false;
  }

  // api 로그인여부 체크
  if (!(await isLoginApi()).data) {
    cmUtil.toast(`로그인하시기 바랍니다.`, { type: "basket" });
    return false;
  }

  const res = await api.post(`${url}/common/updateUserBasketProd`, {
    goodsSn: parm.goodsSn,
    goodsQty: parm.goodsQty,
    cntsStrgYn: parm.cntsStrgYn,
  });

  const { resultCode, data } = res;

  // quickmenu 장바구니 수량 반영
  if (resultCode === 200) {
    store.useBasketCountStore().setBasketCount(data);
  }
  return res;
}
export async function insertUserBasketProd(parm = {}) {
  let validItems = [{ name: "goodsSn", title: "상품번호" }];
  let validMsg = "";
  for (let i = 0; i < validItems.length; i++) {
    if (parm[validItems[i].name] == null || parm[validItems[i].name] == "") {
      validMsg += `${validItems[i].title} 정보가 없습니다.`;
      break;
    }
  }
  if (validMsg) {
    cmUtil.toast(`${validMsg}`, {
      type: "basket",
    });
    return false;
  }

  if (!(await isLoginApi()).data) {
    cmUtil.toast(`로그인하시기 바랍니다.`, { type: "basket" });
    return false;
  }

  // A액(주제) 경우에만 세트제품 체크
  if (parm.zzlqdCls === "A") {
    const res = await orderApi.checkSetProduct(parm.goodsSn);
    if (res.set) {
      parm.goodsSn = res.goodsSn;
    }
  }

  const res = await api.post(`${url}/common/insertUserBasketProd`, {
    goodsSn: parm.goodsSn,
    goodsQty: parm.goodsQty || 1,
    cntsStrgYn: parm.cntsStrgYn || "N",
  });

  const { resultCode, data, message } = res;

  if (resultCode === 200) {
    store.useBasketCountStore().setBasketCount(data);
    cmUtil.toast(`${message}`, { type: "basket" });
  }
  return res;
}
export async function insertUserBasketProds(list = []) {
  let validItems = [{ name: "goodsSn", title: "상품번호" }];
  let validMsg = "";
  for (let r = 0; r < list.length; r++) {
    let parm = list[r];
    for (let i = 0; i < validItems.length; i++) {
      if (parm[validItems[i].name] == null || parm[validItems[i].name] == "") {
        validMsg += `${r + 1}행 ${validItems[i].title} 정보가 없습니다.`;
        break;
      }
    }
  }
  if (validMsg) {
    cmUtil.toast(`${validMsg}`, { type: "basket" });
    return false;
  }
  if (!(await isLoginApi()).data) {
    cmUtil.toast(`로그인하시기 바랍니다.`, { type: "basket" });
    return false;
  }
  const res = await api.post(`${url}/common/insertUserBasketProds`, list);
  const { resultCode, data, message } = res;
  if (resultCode === 200) {
    store.useBasketCountStore().setBasketCount(data);
    cmUtil.toast(`${message}`, { type: "basket" });
  }
  return res;
}
export async function insertUserBookmarkMenu(parm = {}) {
  let validItems = [{ name: "prgrmId", title: "프로그램 ID" }];
  let validMsg = "";
  for (let i = 0; i < validItems.length; i++) {
    if (parm[validItems[i].name] == null || parm[validItems[i].name] == "") {
      validMsg += `${validItems[i].title} 정보가 없습니다.`;
      break;
    }
  }
  if (validMsg) {
    cmUtil.toast(`${validMsg}`, { type: "basket" });
    return false;
  }

  if (!(await isLoginApi()).data) {
    cmUtil.toast(`로그인하시기 바랍니다.`, { type: "basket" });
    return false;
  }

  const res = await api.post(`${url}/common/insertUserBookmarkMenu`, {
    goodsSn: parm.goodsSn,
    goodsQty: parm.goodsQty || 1,
  });
  return res;
}
export async function mergeUserBookmarkMenu(list = []) {
  if (!(await isLoginApi()).data) {
    cmUtil.toast(`로그인하시기 바랍니다.`, { type: "basket" });
    return false;
  }

  const res = await api.post(`${url}/common/mergeUserBookmarkMenu`, list);
  return res;
}
export async function insertUserBookmarkProd(parm = {}) {
  let validItems = [{ name: "goodsSn", title: "상품번호" }];
  let validMsg = "";
  for (let i = 0; i < validItems.length; i++) {
    if (parm[validItems[i].name] == null || parm[validItems[i].name] == "") {
      validMsg += `${validItems[i].title} 정보가 없습니다.`;
      break;
    }
  }
  if (validMsg) {
    cmUtil.toast(`${validMsg}`, { type: "basket" });
    return false;
  }

  if (!(await isLoginApi()).data) {
    cmUtil.toast(`로그인하시기 바랍니다.`, { type: "basket" });
    return false;
  }

  const res = await api.post(`${url}/common/insertUserBookmarkProd`, {
    goodsSn: parm.goodsSn,
    goodsQty: parm.goodsQty || 1,
  });
  return res;
}
export async function insertUserRecentlyProd(parm = {}) {
  let validItems = [{ name: "goodsSn", title: "상품번호" }];
  let validMsg = "";
  for (let i = 0; i < validItems.length; i++) {
    if (parm[validItems[i].name] == null || parm[validItems[i].name] == "") {
      validMsg += `${validItems[i].title} 정보가 없습니다.`;
      break;
    }
  }
  if (validMsg) {
    cmUtil.toast(`${validMsg}`, { type: "basket" });
    return false;
  }

  if (!(await isLoginApi()).data) {
    cmUtil.toast(`로그인하시기 바랍니다.`, { type: "basket" });
    return false;
  }

  const res = await api.post(`${url}/common/insertUserRecentlyProd`, {
    goodsSn: parm.goodsSn,
  });
  return res;
}
export async function deleteUserBasketProd(parm = {}) {
  let validItems = [{ name: "goodsSn", title: "상품번호" }];
  let validMsg = "";
  for (let i = 0; i < validItems.length; i++) {
    if (parm[validItems[i].name] == null || parm[validItems[i].name] == "") {
      validMsg += `${validItems[i].title} 정보가 없습니다.`;
      break;
    }
  }
  if (validMsg) {
    cmUtil.toast(`${validMsg}`, { type: "basket" });
    return false;
  }

  if (!(await isLoginApi()).data) {
    cmUtil.toast(`로그인하시기 바랍니다.`, { type: "basket" });
    return false;
  }

  const res = await api.post(`${url}/common/deleteUserBasketProd`, {
    goodsSn: parm.goodsSn,
  });
  const { resultCode, data } = res;

  // quickmenu 장바구니 수량 반영
  if (resultCode === 200) {
    store.useBasketCountStore().setBasketCount(data);
  }
  return res;
}
export async function deleteUserBasketProds(parm = []) {
  let validItems = [{ name: "goodsSn", title: "상품번호" }];
  let validMsg = "";
  for (let i = 0; i < validItems.length; i++) {
    parm.forEach((item) => {
      if (item[validItems[i].name] == null || item[validItems[i].name] == "") {
        validMsg += `${validItems[i].title} 정보가 없습니다.`;
      }
    });
  }
  if (validMsg) {
    cmUtil.toast(`${validMsg}`, { type: "basket" });
    return false;
  }

  if (!(await isLoginApi()).data) {
    cmUtil.toast(`로그인하시기 바랍니다.`, { type: "basket" });
    return false;
  }

  const res = await api.post(`${url}/common/deleteUserBasketProds`, parm);
  const { resultCode, data } = res;

  // quickmenu 장바구니 수량 반영
  if (resultCode === 200) {
    store.useBasketCountStore().setBasketCount(data);
  }
  return res;
}
export async function deleteUserBookmarkMenu(parm = {}) {
  let validItems = [{ name: "prgrmId", title: "프로그램 ID" }];
  let validMsg = "";
  for (let i = 0; i < validItems.length; i++) {
    if (parm[validItems[i].name] == null || parm[validItems[i].name] == "") {
      validMsg += `${validItems[i].title} 정보가 없습니다.`;
      break;
    }
  }
  if (validMsg) {
    cmUtil.toast(`${validMsg}`, { type: "basket" });
    return false;
  }

  if (!(await isLoginApi()).data) {
    cmUtil.toast(`로그인하시기 바랍니다.`, { type: "basket" });
    return false;
  }

  const res = await api.post(`${url}/common/deleteUserBookmarkMenu`, {
    goodsSn: parm.goodsSn,
  });
  return res;
}
export async function deleteUserBookmarkProd(parm = {}) {
  let validItems = [{ name: "goodsSn", title: "상품번호" }];
  let validMsg = "";
  for (let i = 0; i < validItems.length; i++) {
    if (parm[validItems[i].name] == null || parm[validItems[i].name] == "") {
      validMsg += `${validItems[i].title} 정보가 없습니다.`;
      break;
    }
  }
  if (validMsg) {
    cmUtil.toast(`${validMsg}`, { type: "basket" });
    return false;
  }

  if (!(await isLoginApi()).data) {
    cmUtil.toast(`로그인하시기 바랍니다.`, { type: "basket" });
    return false;
  }

  const res = await api.post(`${url}/common/deleteUserBookmarkProd`, {
    goodsSn: parm.goodsSn,
  });
  return res;
}

export const checkCommonPop = () => {
  const { isMobile } = cmUtil.useDeviceType();
  if (cmUtil.getLocalStorage("gv.commonPop.hiddenDate") !== cmUtil.getToday()) {
    api
      .post(`${url}/common/selectCommonPopupCount`, {
        deviceType: isMobile.value ? "M" : "P",
      })
      .then((res) => {
        const count = res.data || 0;
        if (count > 0) {
          store.useEventBusStore().setIsCommonPop(true);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
};

export const closeCommonPop = (option = "") => {
  if (option === "todayHide") {
    cmUtil.setLocalStorage("gv.commonPop.hiddenDate", cmUtil.getToday());
  }
  store.useEventBusStore().setIsCommonPop(false);
};

export const checkCookiePop = () => {
  const user = store.useAuthStore()?.user;
  if (!user) {
    return false;
  }
  if (user.cookieUserAgreeYn !== "Y") {
    store.useEventBusStore().setIsCookiePop(true);
  }
};

export async function updateUserPersonInfo(parm = {}) {
  if (!(await isLoginApi()).data) {
    cmUtil.toast(`로그인하시기 바랍니다.`, { type: "basket" });
    return false;
  }
  const res = await api.post(`${url}/common/updateUserPersonInfo`, parm);

  // 쿠키 동의하면 쿠키팝업 닫는다
  if (parm.type === "cookieUserAgreeYn") {
    if (parm.cookieUserAgreeYn === "Y") {
      store.useEventBusStore().setIsCookiePop(false);
    }
  }
  return res;
}
export async function fileDownload(parm = {}) {
  let validItems = [
    { name: "fileSn", title: "파일 번호" },
    { name: "dtlSn", title: "상세 번호" },
  ];
  let validMsg = "";
  for (let i = 0; i < validItems.length; i++) {
    if (parm[validItems[i].name] == null || parm[validItems[i].name] == "") {
      validMsg += `${validItems[i].title} 정보가 없습니다.`;
      break;
    }
  }
  if (validMsg) {
    cmUtil.toast(`${validMsg}`, { type: "basket" });
    return false;
  }

  try {
    const response = await axios.get(`${url}/file/fileDonwload`, {
      params: { fileSn: parm.fileSn, dtlSn: parm.dtlSn },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      responseType: "arraybuffer",
    });

    let fileName = "unknown";
    if (response.headers["content-disposition"]) {
      const [fileNameMatch] = response.headers["content-disposition"]
        .split(";")
        .filter((str) => str.includes("filename"));
      if (fileNameMatch) [, fileName] = fileNameMatch.split("=");
    }

    const blob = new Blob([Buffer.from(response.data, "binary")]);
    const _url = window.URL.createObjectURL(blob);
    const _link = document.createElement("a");
    _link.href = _url;
    // _link.download = response.headers["xx-file"];
    _link.setAttribute("download", decodeURIComponent(fileName)); // 파일 이름 설정
    _link.click();
    window.URL.revokeObjectURL(_url);
  } catch (e) {
    if (e.status === 401) {
      cmUtil.toast(`인증정보를 확인해주시기 바랍니다.`, { type: "basket" });
    } else {
      cmUtil.toast(`파일다운로드중 오류가 발생했습니다`, { type: "basket" });
    }
    console.log(e);
  }
}